// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"livestream_tooltip__11wKi"};